export default {"src":"https://cloudflare.edhrec.com/_next/static/media/mana8.e0e82306.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};